export enum DossierPriority {
    Low = "Low",
    MediumLow = "MediumLow",
    Medium = "Medium",
    MediumHigh = "MediumHigh",
    High = "High",
}
